import {
  type Assign,
  Toast as ArkToast,
  PolymorphicProps,
} from "@ark-ui/react";
// @ts-expect-error: library is not imported
import * as toast from "@zag-js/toast";
import { HTMLStyledProps } from "@zenchef/styled-system/jsx";
import {
  aromaToast,
  AromaToastVariantProps,
} from "@zenchef/styled-system/recipes";
import { IconName } from "@zenchef/icomoon/dist/aromaticons/types";
import { slots } from "../../theme/recipes/toast";
import { createStyleContext, Slot } from "../../utils/createStyleContext";
import Icon from "../Icon/Icon";

const { withProvider, withContext } = createStyleContext(aromaToast);

export interface ToastRootProps
  extends Assign<HTMLStyledProps<"div">, PolymorphicProps>,
    AromaToastVariantProps {}

export type ToastSlots = Slot<typeof aromaToast>;

export const slotsMaps: Record<ToastSlots, ToastSlots> = slots.reduce(
  (acc, slot) => ({ ...acc, [slot]: slot }),
  {} as Record<ToastSlots, ToastSlots>,
);

export const ToastRoot = withProvider<
  HTMLDivElement,
  Assign<HTMLStyledProps<"div">, ArkToast.RootProps & AromaToastVariantProps>
>(ArkToast.Root, slotsMaps.root);

export const ToastActionTrigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<"button">, ArkToast.ActionTriggerProps>
>(ArkToast.ActionTrigger, slotsMaps.actionTrigger);

export const ToastDescription = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<"div">, ArkToast.DescriptionProps>
>(ArkToast.Description, slotsMaps.description);

export const ToastTitle = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<"div">, ArkToast.TitleProps>
>(ArkToast.Title, slotsMaps.title);

export const ToastIcon = withContext<
  HTMLElement,
  Assign<HTMLStyledProps<"div">, { name: IconName }>
>(Icon, slotsMaps.icon);

export type ToastProps = Omit<toast.Options<React.ReactNode>, "type"> & {
  type: "neutral" | "info" | "success" | "warning";
  meta: {
    icon: IconName;
  };
};

export {
  Toaster as ArkToaster,
  createToaster,
  type CreateToasterReturn,
} from "@ark-ui/react";
